export const en = {
    visits: {
        list: {
            visitorName: "Visitor",
            email: "Email",
            date: "Date",
            hour: "Hour",
            checkInOut: "Check-in/out Time",
            checkOutTime: "Check-out Time",
            checkInTime: "Check-in Time",
            building: "Building",
            visitHost: "Host Name",
            checkOutType: "Check-out Type",
            manualCheckOut: "Manual Check-out",
            manualCheckIn: "Manual Check-In"
        },
        alerts: {
            checkOut: {
                title: "Check-out",
                success: {
                    title: "Check-out Successful",
                    text: "Entries successfully checked-out",
                },
                error: {
                    title: "Check-out Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            checkIn: {
                title: "Check-In",
                success: {
                    title: "Check-In Successful",
                    text: "Entries successfully checked-in",
                },
                error: {
                    title: "Check-in Error",
                    text: "Something went wrong. Please try again later",
                }
            },
            createCheckIn: {
                title: "Create Visit",
                text: "Are you sure you want to create a visit for %{visitorName}?",
                success: {
                    title: "Visit Create Successful",
                    text: "Visitor was successfully checked-in",
                },
                error: {
                    title: "Visit Create Error",
                    text: "Something went wrong. Please try again later",
                }
            }
        },
        searchFields: {
            visitorName: "Visitor",
            userEmail: "Host Name",
            building: "Building",
            meeting: "Meeting"
        },
        form: {
            headers: {
                create: "Check In",
                view: "Check In",
            },
            building: "Building",
            visitorEmail: "Visitor Email",
            visitHost: "Host Name",
            name: "Visitor Name",
            company: "Visitor Company",
            mobilePhone: "Mobile Phone",
        },
        checkOutTypes: {
            MANUAL: "Manual",
            AUTOMATIC: "Automatic",
            BACKOFFICE: "Back-office",
            undefined: " ",
        },
        permissions: {
            VISITS: 'Visits | Visitors',
            CREATE_VISITOR: 'Create Visitor',
            UPDATE_VISITOR: 'Update Visitor',
            READ_VISITOR: 'Read Visitor',
            READ_VISIT: 'Read Visit',
            CHECKIN_VISIT: 'Check-In Visit',
            CHECKOUT_VISIT: 'Check-Out Visit'
        }
    }
};